// JOBE-0158.6: PromptOps sub-nav — Fleet · Suites · Memory · (Agent: name)?
//
// Horizontal third-layer nav rendered between the top-nav and the page
// header on all PromptOps surfaces (W5/W6/W7/W8). The conditional Agent
// slot appears only when `agentName` is a non-empty string.
//
// API contract (pinned in ADR-0034 D13):
//   <PromptOpsSubNav agentName={'sara' | null} />

import { Link, useLocation } from 'react-router-dom';
import './PromptOpsSubNav.css';

/** Title-case the first letter only; leave the rest as-supplied. */
function titleFirst(str) {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const SLOTS = [
  { key: 'fleet',  label: 'Fleet',  to: '/promptops/fleet' },
  { key: 'suites', label: 'Suites', to: '/promptops/suites' },
  { key: 'memory', label: 'Memory', to: '/promptops/memory' },
];

export function PromptOpsSubNav({ agentName }) {
  // Validate agentName: empty string is invalid — warn and treat as null.
  let resolvedAgent = agentName;
  if (agentName !== null && agentName !== undefined && typeof agentName === 'string' && agentName.trim() === '') {
    console.warn(
      '[PromptOpsSubNav] agentName provided but is an empty string; ' +
      'treating as null and hiding the Agent slot.',
    );
    resolvedAgent = null;
  }

  const { pathname } = useLocation();

  /**
   * A slot is "active" when the current pathname starts with the slot's
   * path prefix. This keeps deep sub-routes (e.g. /promptops/suites/abc)
   * highlighting the correct slot.
   *
   * Special case for Fleet: /promptops/fleet matches, and the bare
   * /promptops root is treated as Fleet too.
   */
  function isActive(slotPath) {
    if (slotPath === '/promptops/fleet') {
      return pathname === '/promptops' || pathname.startsWith('/promptops/fleet');
    }
    return pathname.startsWith(slotPath);
  }

  const agentSlotActive = resolvedAgent
    ? pathname.startsWith('/promptops/agent/')
    : false;

  const slots = [...SLOTS];
  if (resolvedAgent) {
    slots.push({
      key: 'agent',
      label: `Agent: ${titleFirst(resolvedAgent)}`,
      to: `/promptops/agent/${resolvedAgent}`,
    });
  }

  return (
    <nav className="promptops-subnav" aria-label="PromptOps sub-navigation">
      {slots.map((slot, idx) => {
        const active = slot.key === 'agent' ? agentSlotActive : isActive(slot.to);
        return (
          <span key={slot.key} className="promptops-subnav__item-wrap">
            {idx > 0 && <span className="promptops-subnav__sep" aria-hidden="true" />}
            <Link
              to={slot.to}
              className={`promptops-subnav__link${active ? ' promptops-subnav__link--active' : ''}`}
              aria-current={active ? 'page' : undefined}
            >
              {slot.label}
            </Link>
          </span>
        );
      })}
    </nav>
  );
}
